import ProfileApi from '@/profile/api';
import { addFile, FILE_TYPES } from '@/core/api/files/files';

// TODO: type this — Vuex module context and profile object types
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface Profile {
    id?: string;
    imageUrl?: string;
    hasSeenFPSplash?: boolean;
    groups?: unknown[];
    [key: string]: unknown;
}

interface ProfileState {
    me: Profile;
    showEditor: boolean;
    profiles: Record<string, Profile>;
    profileLoadPromises: Record<string, Promise<Profile>>;
}

const ProfileStore = {
    namespaced: true,
    state: {
        me: {} as Profile,
        showEditor: false,
        profiles: {} as Record<string, Profile>,
        profileLoadPromises: {} as Record<string, Promise<Profile>>,
    },
    getters: {
        getImage: (state: ProfileState) => (id: string) => {
            if (id == state.me.id) {
                return state.me.imageUrl;
            } else if (Object.prototype.hasOwnProperty.call(state.profiles, id)) {
                return state.profiles[id].imageUrl;
            }
            return '/static/icons/layout/mythic_wolf.svg';
        },
        getProfile: (state: ProfileState) => (id: string) => {
            if (id == state.me.id) {
                return state.me;
            } else if (Object.prototype.hasOwnProperty.call(state.profiles, id)) {
                return state.profiles[id];
            }
            return null;
        },
        getGroups: (state: ProfileState) => (id: string) => {
            if (id == state.me.id) {
                return state.me.groups;
            } else if (Object.prototype.hasOwnProperty.call(state.profiles, id)) {
                return state.profiles[id].groups;
            }
        },
    },
    mutations: {
        me(state: ProfileState, profile: Profile): void {
            state.me = profile;
        },
        updateImage(state: ProfileState, image: string): void {
            state.me.imageUrl = image;
        },
        profile(state: ProfileState, profile: Profile): void {
            state.profiles[profile.id!] = profile;
        },
        setShowEditor(state: ProfileState, show: boolean): void {
            state.showEditor = show;
        },
    },
    actions: {
        async me({ commit }: Ctx): Promise<Profile> {
            const me = (await ProfileApi.me()) as Profile;
            commit('me', me);
            return me;
        },
        edit({ commit }: Ctx, show: boolean): void {
            commit('setShowEditor', show);
        },
        async uploadImage({ commit }: Ctx, event: Ctx): Promise<void> {
            const files = event && event.target && event.target.files;
            const results = (await addFile(files, FILE_TYPES.PROFILE)) as {
                data: { count: number; files: { url: string }[] };
            };
            if (results.data.count > 0) {
                commit('updateImage', results.data.files[0].url);
            }
        },
        async update({ commit }: Ctx, profile: Profile): Promise<Profile> {
            const me = (await ProfileApi.update(profile)) as Profile;
            commit('me', me);
            return me;
        },
        async load({ commit, state }: Ctx, id: string): Promise<Profile> {
            if (Object.prototype.hasOwnProperty.call(state.profileLoadPromises, id)) {
                return await state.profileLoadPromises[id];
            }
            state.profileLoadPromises[id] = ProfileApi.get(id) as Promise<Profile>;
            const profile = await state.profileLoadPromises[id];
            delete state.profileLoadPromises[id];
            commit('profile', profile);
            return profile;
        },
        async loadMultiple({ dispatch }: Ctx, ids: string[]): Promise<unknown[]> {
            const profiles = ids.map((id: string) => dispatch('load', id));
            return profiles;
        },
    },
};

export default ProfileStore;
